import React, { useState, useEffect } from 'react'
import ReviewsDetails from '../components/ReviewsDetails'
import { Tabs, TabsContent } from '../components/ui/tabs'

const Reviews = () => {
  const [activeTab, setActiveTab] = useState("all")
  const [reviews, setReviews] = useState([])
  const [featuredReviews, setFeaturedReviews] = useState([])

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/bonuses`)
        const data = await res.json()
        setReviews(data)
      } catch (err) {
        console.error("Failed to fetch reviews:", err)
      }
    }

    const fetchFeaturedReviews = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/bonuses/featured`)
        const data = await res.json()
        setFeaturedReviews(Array.isArray(data) ? data : [])
      } catch (err) {
        console.error("Failed to fetch featured bonuses:", err)
      }
    }

    fetchReviews()
    fetchFeaturedReviews()
  }, [])

  

  const featuredReviewIds = new Set(
    featuredReviews
      .map((item) => item._id?.toString())
      .filter(Boolean)
  )

  const filteredReviews =
    activeTab === "all"
      ? reviews.filter((item) => !featuredReviewIds.has(item._id?.toString()))
      : reviews.filter(
          (item) => item.games?.includes(activeTab) && !featuredReviewIds.has(item._id?.toString())
        )

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Hero Section */}
      <div className="text-center mb-12 relative">
        <h1 className="text-4xl font-bold mb-4 font-display bg-gradient-to-r from-[#FF6B00] via-[#FF9A3D] to-[#FFD700] bg-clip-text text-transparent drop-shadow-glow">
          Bonuses
        </h1>
        <p className="text-blue-100/70 max-w-2xl mx-auto">
          Find exclusive bonus codes and claim offers from the best websites.
        </p>
      </div>

      {/* Tabs Filter */}
      <Tabs defaultValue="all" value={activeTab} onValueChange={setActiveTab} className="mb-8">

        {featuredReviews.length > 0 && (
          <section className="mb-10 rounded-3xl border border-[#FF6B00]/20 bg-gradient-to-br from-[#FF6B00]/10 via-[#1A1D21]/70 to-[#0F1215]/80 p-5 shadow-[0_0_40px_rgba(255,107,0,0.12)] backdrop-blur-sm">
            <div className="flex items-center justify-between gap-4 mb-6">
              <h2 className="text-3xl font-display text-white">Featured Websites</h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {featuredReviews.map((item, index) => (
                <div key={item._id || `${item.website}-${index}`} className="rounded-2xl border border-[#FF6B00]/20 bg-[#0F1215]/70 p-2 shadow-[0_0_24px_rgba(255,107,0,0.08)]">
                  <ReviewsDetails
                    website={item.website}
                    affiliateLink={item.affiliateLink}
                    review={item.review}
                    logo={item.logo}
                    code={item.code}
                    games={item.games}
                    rtp={item.rtp}
                  />
                </div>
              ))}
            </div>
            <p className="mt-6 text-center text-sm text-blue-100/80">
              Want your website featured here? Contact <span className="text-[#FF6B00]">CaseRTP.team@gmail.com</span> to reserve a spot.
            </p>
          </section>
        )}

        <div className="flex justify-center mb-8">
          <div className="flex gap-2 bg-[#1A1D21]/40 border border-[#2A2D31]/50 p-2 rounded-2xl backdrop-blur-sm">
            {["all", "cs", "rust", "slots"].map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveTab(filter)}
                className={`px-5 py-2 rounded-xl text-sm font-medium transition-all ${
                  activeTab === filter
                    ? "!bg-gradient-to-r from-[#FF6B00] to-[#FF9A3D] text-white"
                    : "!bg-[#0F1215]/80 text-blue-100/80 hover:border-[#FF6B00]/50 border border-[#2A2D31]/50"
                }`}
              >
                {filter === "all" ? "All" : filter.toUpperCase()}
              </button>
            ))}
          </div>
        </div>

        {/* Dynamic Content Based on Active Tab */}
        <TabsContent value={activeTab}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredReviews.map((item, index) => (
              <ReviewsDetails
                key={index}
                website={item.website}
                affiliateLink={item.affiliateLink}
                review={item.review}
                logo={item.logo}
                code={item.code}
                games={item.games}
                rtp={item.rtp}
              />
            ))}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  )
}

export default Reviews
